import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_CATEGORY_CREATE,
  IN_ROOM_DINING_CATEGORY_VIEW,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  activateInRoomDiningCategoty,
  deactivateInRoomDiningCategoty,
  deleteInRoomDiningCategory,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  uploadIRDCategoriesByCSV,
} from '../../../../../utils/ServicesAPIUtils';
import {
  fetchAllInRoomDining,
  inRoomDiningCategorySelector,
  inRoomDiningMenuSelector,
  setInRoomDiningCategory,
} from '../../../servicesSlice';
import CategoryListTable from './Category-List-Table';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import './Category-List-Table.scss';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import {
  getCheckedIds,
  updateCheckedStatus,
  validateAlphanumeric,
  generateConfirmationMessage,
  selectedCheckList,
  ResetFilterList,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { WEEK_DAYS } from '../../../../../constants/DashboardConst';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import { allHotelsSelector } from '../../../../property/propertySlice';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InRoomDiningCategoryList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    inRoomDiningLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;
  const inRoomDiningCategory = useSelector(inRoomDiningCategorySelector);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    warn: false,
    anchorEl: null,
  });
  const dispatch = useDispatch();
  const selectedHotel = useSelector(allHotelsSelector);
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  useEffect(() => {
    setCategoryList(
      inRoomDiningCategory?.map((category) => {
        return {
          ...category,
          isChecked: false,
        };
      }),
    );
    setSearchText('');
  }, [inRoomDiningCategory]);

  useEffect(() => {
    if (inRoomDiningLoader || categoryList?.length === 0) return;
    const totalItems = categoryList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [categoryList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const getCheckedCategoryList = categoryList?.filter((Category) => Category?.isChecked);

  const listOfCategoryIds = getCheckedCategoryList?.map((Category) => Category.id);

  const selectedCategoryLength = getCheckedCategoryList?.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(categoryList, 'isChecked');
    const filteredRows = await inRoomDiningCategory.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setCategoryList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedCategoryLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setCategoryList(ResetFilterList);
    }
  };

  const dragDisabled = isDragDisabled(categoryList, searchText);

  const onOpenDrawer = (event, type) => {
    if (selectedCategoryLength) {
      setCategoryList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.category);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      warn: false,
      anchorEl: null,
      category: null,
    });
  };

  const onClickRowViewDetails = (categoryItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_CATEGORY_VIEW, true, categoryItem);
    }
  };

  const onViewDetails = () => {
    onViewToggle(IN_ROOM_DINING_CATEGORY_VIEW, true, selectedValue.category);
  };

  const handleCellMenuClick = (event, category) => {
    if (selectedCategoryLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: category.id,
        name: '',
        title: '',
        description: '',
        status: false,
        warn: false,
        anchorEl: event.currentTarget,
        category,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onDelete = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (selectedValue && selectedValue?.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        await deleteInRoomDiningCategory(selectedValue.id, hotelId, restaurantId, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Category deleted successfully');
      }
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Unable to delete Category',
      );
      handleClose();
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const checkUsageInMenu = () => {
    let isUsed = inRoomDiningMenu.some((ird) =>
      ird.categories.some((category) => category.id === selectedValue.id),
    );
    return isUsed;
  };

  const onDeleteCategory = (event) => {
    event.preventDefault();
    if (checkUsageInMenu()) {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        name: prev.category.name,
        status: false,
        warn: true,
        anchorEl: null,
        description: 'The selected category cannot be deleted as it is being added to a Menu',
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        name: prev.category.name,
        description: 'This action cannot be reversed',
        status: true,
        warn: false,
        anchorEl: null,
      }));
    }
  };

  const onDeleteCancel = () => {
    handleClose();
  };

  const onActiveDeActiveCategoty = async (e, type) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      if (type === 'deactivate') {
        await deactivateInRoomDiningCategoty(selectedValue.id, hotelId, restaurantId, language);
      } else {
        await activateInRoomDiningCategoty(selectedValue.id, hotelId, restaurantId, language);
      }
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager(
        'success',
        `Category ${type === 'deactivate' ? 'deactivated' : 'activated'} successfully`,
      );
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : `Category not ${type} `,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const isAvailable = (data) => {
    const convertedWeeks = WEEK_DAYS.map((x) => x.toLowerCase());
    const containsAll = data?.every((element) => {
      return convertedWeeks.includes(element.toLowerCase().trim());
    });
    return containsAll;
  };

  const isValidStatus = (status) => {
    const tempStatus = status.toLowerCase().trim();
    return tempStatus === 'yes' || tempStatus === 'no';
  };

  const normalizeTime = (t) => {
    const parts = (t || '').trim().split(':');
    if (parts.length !== 2) return t;
    return parts[0].padStart(2, '0') + ':' + parts[1];
  };

  const TIME_RANGE_REGEX = /^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/;

  const validateHour = (time) => {
    const s = (time || '').trim();
    if (s === '24*7') return true;
    const ranges = s.split(',').map((r) => r.trim()).filter(Boolean);
    if (ranges.length === 0) return false;
    return ranges.every((r) => TIME_RANGE_REGEX.test(r));
  };

  const parseTimeRanges = (hoursStr) => {
    const s = (hoursStr || '').trim();
    if (!s) return [];
    if (s === '24*7' || s.toLowerCase() === '00:00-23:59') {
      return [{ from: 'all day', to: 'all day' }];
    }
    const ranges = s.split(',').map((r) => r.trim()).filter(Boolean);
    return ranges.map((r) => {
      const match = r.match(TIME_RANGE_REGEX);
      if (!match) return null;
      return { from: normalizeTime(match[1]), to: normalizeTime(match[2]) };
    }).filter(Boolean);
  };

  const handleCsvFileData = (categoryListData) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = categoryListData.filter((row) => !isTemplateInstructionRow(row));
    const errors = [];
    if (filteredItemList.length === 0) {
      errors.push('No data rows found in the uploaded file.');
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const nameCounts = {};
    const codeCounts = {};
    const dbNames = new Set((categoryList || []).map(ch => ch?.name?.trim()?.toLowerCase()).filter(Boolean));
    const dbCodes = new Set((categoryList || []).map(ch => ch?.code?.trim()?.toLowerCase()).filter(Boolean));

    const nameFreq = Object.create(null);
    const codeFreq = Object.create(null);

    filteredItemList.forEach(item => {
      const nK = (item?.categoryName || '').trim().toLowerCase();
      const cK = (item?.categoryCode || '').trim().toLowerCase();
      if (nK) nameFreq[nK] = (nameFreq[nK] || 0) + 1;
      if (cK) codeFreq[cK] = (codeFreq[cK] || 0) + 1;
    });

    const fileDupNames = new Set(Object.keys(nameFreq).filter(k => nameFreq[k] > 1));
    const fileDupCodes = new Set(Object.keys(codeFreq).filter(k => codeFreq[k] > 1));

    const newItems = [];
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];
      if (!item.categoryName?.trim()) {
        rowErrors.push('"Category Name" is empty');
      } else {
        if (item.categoryName.trim().length > 100) rowErrors.push('"Category Name" exceeds 100 characters');
      }
      if (!item.categoryCode?.trim()) {
        rowErrors.push('"Category Code" is empty');
      } else {
        if (item.categoryCode.trim().length > 8) rowErrors.push('"Category Code" exceeds 8 characters');
        if (!validateAlphanumeric(item.categoryCode.trim())) rowErrors.push('"Category Code" must be alphanumeric');
      }
      if (item.availableOn?.trim() && item.availableOn.trim().toLowerCase() !== 'everyday' && !isAvailable(item.availableOn.split(','))) {
        rowErrors.push('"Available On" contains invalid day(s)');
      }
      if (item.hours?.trim() && !validateHour(item.hours)) {
        rowErrors.push('"Hours" format is invalid (use HH:mm-HH:mm or multiple comma-separated ranges, or 24*7)');
      }
      if (item.availableOn?.trim() && item.availableOn.trim().toLowerCase() !== 'everyday' && item.hours?.trim() && item.hours.trim() !== '24*7') {
        const dayCount = item.availableOn.split(',').map((d) => d.trim()).filter(Boolean).length;
        const timeCount = item.hours.split(',').map((r) => r.trim()).filter(Boolean).length;
        if (timeCount > 1 && timeCount !== dayCount) {
          rowErrors.push(`"Hours" has ${timeCount} time range(s) but "Available On" has ${dayCount} day(s) — must be 1 range for all days, or one range per day`);
        }
      }
      if (item.hours?.trim() && item.hours.trim() !== '24*7' && validateHour(item.hours)) {
        const dayCount = item.availableOn?.trim()
          ? (item.availableOn.trim().toLowerCase() === 'everyday' ? 7 : item.availableOn.split(',').map((d) => d.trim()).filter(Boolean).length)
          : 0;
        if (dayCount === 1) {
          const ranges = parseTimeRanges(item.hours);
          ranges.forEach((tr, idx) => {
            if (tr.from !== 'all day' && tr.from > tr.to) {
              rowErrors.push(`"Hours" has invalid time range "${tr.from}-${tr.to}" — start time cannot be after end time for a single day`);
            }
          });
        }
      }
      if (item.active?.trim() && !isValidStatus(item.active)) rowErrors.push('"Active" must be Yes or No');
      
      const nK = (item?.categoryName || '').trim().toLowerCase();
      const cK = (item?.categoryCode || '').trim().toLowerCase();
      const nameExists = nK && (dbNames.has(nK) || fileDupNames.has(nK));
      const codeExists = cK && (dbCodes.has(cK) || fileDupCodes.has(cK));

      if (nameExists || codeExists) {
        const reasons = [];
        if (nameExists) reasons.push(`name '${(item?.categoryName || '').trim()}'`);
        if (codeExists) reasons.push(`code '${(item?.categoryCode || '').trim()}'`);
        rowErrors.push(`Already exists or duplicated in file (${reasons.join(' and ')})`);
      }

      if (rowErrors.length > 0) {
        errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
      } else {
        newItems.push(item);
      }
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
      return;
    }

    if (newItems.length > 0) {
      const listToUpload = newItems.map((item) => {
        let selectedDay = null;
        const isEveryday = item?.availableOn && item?.availableOn.trim().toLowerCase() === 'everyday';
        const timeRanges = parseTimeRanges(item?.hours);
        const isAllDay = timeRanges.length > 0 && timeRanges[0].from === 'all day';
        if (isEveryday) {
          const timings = timeRanges.length > 0
            ? timeRanges.map((tr) => ({ day: 'EVERYDAY', from: tr.from, to: tr.to }))
            : [{ day: 'EVERYDAY', from: 'all day', to: 'all day' }];
          selectedDay = { allTime: isAllDay, everyday: true, timings };
        } else if (item.availableOn?.trim()) {
          const days = item.availableOn.split(',').map((d) => d.trim()).filter(Boolean);
          const timings = [];
          if (timeRanges.length <= 1) {
            const tr = timeRanges[0] || { from: 'all day', to: 'all day' };
            for (const day of days) {
              timings.push({ day: day.toUpperCase(), from: tr.from, to: tr.to });
            }
          } else {
            for (let i = 0; i < days.length; i++) {
              const tr = timeRanges[i];
              if (tr) timings.push({ day: days[i].toUpperCase(), from: tr.from, to: tr.to });
            }
          }
          selectedDay = { allTime: isAllDay, everyday: false, timings };
        } else {
          selectedDay = { allTime: false, everyday: false, timings: [] };
        }
        return {
          name: item?.categoryName,
          code: item?.categoryCode,
          description: item?.description,
          status: item?.active?.trim()?.toUpperCase() === 'YES' ? true : false,
          customAttributes: [],
          hours: selectedDay,
          hotelId,
          restaurantId,
        };
      });
      setValidationErrors([]);
      setCsvValidateError(false);
      handleCsvDataSubmit(listToUpload);
    } else {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
    }
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const payload = {
        isReplace: false,
        hotelId: hotelId,
        category: payloadLists,
        restaurantId,
      };
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const res = await uploadIRDCategoriesByCSV(payload, language);
      if (res?.data?.uploadIRDCategoryByCSV?.status === 'Success') {
        setCsvUploadStatus('success');
      } else {
        setCsvUploadStatus('error');
      }
    } catch (e) {
      setCsvUploadErrorMsg(null);
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const generateExportData = (category) => {
    const tempList = category?.map((e) => {
      const activeStatus = e?.status ? 'YES' : 'NO';
      const description = e?.description;
      const availableOn =
        e.hours?.timings[0]?.day === 'EVERYDAY'
          ? 'Everyday'
          : `${e.hours?.timings?.map((timing) => timing.day?.toLowerCase()).join(',')}`;
      const hours =
        e.hours?.timings.length !== 0
          ? e.hours?.timings[0]?.from === 'all day'
            ? '00:00-23:59'
            : `${e.hours?.timings[0]?.from}-${e.hours?.timings[0]?.to}`
          : '';

      return {
        ...e,
        active: `"${activeStatus}"`,
        description: `"${description}"`,
        availableOn: `"${availableOn}"`,
        hours: `"${hours}"`,
      };
    });

    const fields = ['name', 'code', 'description', 'active', 'availableOn', 'hours'];

    return tempList.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const generateHeaders = [
    { label: 'Category Name', key: 'name' },
    { label: 'Category Code', key: 'code' },
    { label: 'Description', key: 'description' },
    { label: 'Active', key: 'active' },
    { label: 'Available On', key: 'availableOn' },
    { label: 'Hours', key: 'hours' },
  ];

  const handleExport = () => {
    let selectedValue = categoryList?.filter((item) => item?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_category.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_categories.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_categories.csv`;
      exportData = generateExportData(categoryList);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((item) =>
        generateHeaders?.map((header) => item[header.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleAction = (actionName) => {
    let selectedDiscount = categoryList?.filter((item) => item?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedDiscount?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedDiscount?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedDiscount?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = categoryList?.findIndex((category) => category.id === id);
    if (!categoryList[index]?.isChecked) {
      categoryList[index] = { ...categoryList[index], isChecked: true };
    } else {
      categoryList[index].isChecked = !categoryList[index]?.isChecked;
    }
    setCategoryList([...categoryList]);

    let actionList = categoryList
      ?.filter((category) => category?.isChecked)
      .map((status) => status?.status);

    const checkedItems = categoryList?.filter((category) => category?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = categoryList?.every((category) => category?.isChecked);
    setIsAllSelected(isAllSelected);
    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedItemList = categoryList?.map((category) => {
      return {
        ...category,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedItemList?.some((category) => category?.status);
    const isInactive = selectedItemList?.some((category) => !category.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setCategoryList([...selectedItemList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedItemList.some((category) => category?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = `${
    listOfCategoryIds.length > 1 ? 'categories' : 'category'
  } ${isActive ? 'activated' : 'deactivated'} successfully.`;

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setCategoryList(
      inRoomDiningCategory.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_CATEGORY';
      await updateSelectedItemsStatus(
        listOfCategoryIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Category was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_CATEGORY';
      await deleteSelectedItems(
        listOfCategoryIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Category deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Category',
      );
    }
    setActionMenuList([]);
    setIsAllSelected(false);
  };
  return (
    <div className='mt-4 mb-4 group-list-container'>
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Category'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Category'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+configs+Category.zip'}
        />
      </Dialog>
      <SearchBar
        type={IN_ROOM_DINING_CATEGORY_CREATE}
        buttonName='Add Category'
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        filterList={[]}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={categoryList}
        setPlaceHolder={setCategoryList}
        globalPlaceHolder={inRoomDiningCategory}
        setGlobalPlaceHolder={setInRoomDiningCategory}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining category'
        module='IRD_CATEGORY'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        //temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // exportData={generateExportData(categoryList)}
        // headers={generateHeaders}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {inRoomDiningLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <CategoryListTable
          page={page}
          rowsPerPage={rowsPerPage}
          dragDisabled={dragDisabled}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          permissions={permissions}
          handleCellMenuClick={handleCellMenuClick}
          categoryList={categoryList}
          setCategoryList={setCategoryList}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onDeleteCategory={onDeleteCategory}
          onActiveDeActiveCategoty={onActiveDeActiveCategoty}
          setVisible={setVisible}
          searchText={searchText}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          handleCheckboxChange={handleCheckboxChange}
          handleSelectAll={handleSelectAll}
          setActionMenuList={setActionMenuList}
          selectedCategoryLength={selectedCategoryLength}
          inRoomDiningCategory={inRoomDiningCategory}
        />
      </div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
      {selectedValue.id && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}{' '}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCategoryLength} ${
            selectedCategoryLength > 1 ? 'categories' : 'category'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}
      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCategoryLength}  ${
            selectedCategoryLength > 1 ? 'categories' : 'category'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
    </div>
  );
};

export default InRoomDiningCategoryList;
